import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { authApi, getStoredToken, setStoredToken } from 'api';
import { markWelcomeAfterLogin } from 'constants/welcome';
if (typeof window !== 'undefined') {
  window.__AUTH_DEBUG__ = window.__AUTH_DEBUG__ || [];
  const d = (m, o) => { window.__AUTH_DEBUG__.push({ t: Date.now(), msg: m, ...o }); console.log('[AUTH]', m, o); };
  window.__authDebug = d;
}

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [user, setUser] = useState(null);

  const checkAuth = useCallback(async () => {
    const token = getStoredToken();
    if (!token) {
      setIsAuthenticated(false);
      setUser(null);
      setIsLoading(false);
      return;
    }
    setStoredToken(token); // синхронизировать axios defaults с localStorage
    try {
      const userData = await authApi.user();
      setUser(userData);
      setIsAuthenticated(true);
    } catch {
      setStoredToken(null);
      setUser(null);
      setIsAuthenticated(false);
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    checkAuth();
  }, [checkAuth]);

  const login = async (email, password) => {
    const data = await authApi.login(email, password);
    const token = data?.token ?? data?.access_token ?? data?.data?.token;
    if (!token) {
      throw new Error('Токен не получен от сервера');
    }
    const userData = data?.user ?? data?.data?.user ?? { email, name: email };
    if (typeof window !== 'undefined' && window.__authDebug) {
      window.__authDebug('AuthContext login SUCCESS', { tokenLen: token?.length, preview: token?.slice(0, 20), dataKeys: data ? Object.keys(data) : [] });
    }
    setStoredToken(token);
    setUser(userData);
    markWelcomeAfterLogin();
    await new Promise((r) => setTimeout(r, 100));
    setIsAuthenticated(true);
  };

  const logout = async () => {
    try {
      await authApi.logout();
    } catch {
      // ignore
    } finally {
      setStoredToken(null);
      setUser(null);
      setIsAuthenticated(false);
    }
  };

  return (
    <AuthContext.Provider value={{ isAuthenticated, isLoading, user, setUser, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
}
